/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_Ai_ModelsInputs */

const en_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Models`)
};

const fr_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèles d'IA`)
};

const de_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Modelle`)
};

const it_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelli di intelligenza artificiale`)
};

const ru_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модели искусственного интеллекта`)
};

const es_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelos de IA`)
};

const zh_cn2_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工智能模型`)
};

const ja_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIモデル`)
};

const hi_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एआई मॉडल`)
};

const pt_pt2_ad_section_ai_models = /** @type {(inputs: Ad_Section_Ai_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelos de IA`)
};

/**
* | output |
* | --- |
* | "AI Models" |
*
* @param {Ad_Section_Ai_ModelsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_ai_models = /** @type {((inputs?: Ad_Section_Ai_ModelsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_Ai_ModelsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_section_ai_models(inputs)
	if (locale === "de") return de_ad_section_ai_models(inputs)
	if (locale === "it") return it_ad_section_ai_models(inputs)
	if (locale === "ru") return ru_ad_section_ai_models(inputs)
	if (locale === "es") return es_ad_section_ai_models(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_section_ai_models(inputs)
	if (locale === "ja") return ja_ad_section_ai_models(inputs)
	if (locale === "hi") return hi_ad_section_ai_models(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_section_ai_models(inputs)
	return en_ad_section_ai_models(inputs)
});